import FormattedMessage from 'I18n/components/FormattedMessage';
import { CONTENT_PLATFORM_PROPERTY_NAME, getPropertyValue } from 'content-management-data-lib';
import { PAGE_PROPERTY_NAMES } from 'page-lib/constants/propertyNames';
import { getContentDynamicPageHubDbTableId } from '../utils/dynamicPageUtils';
import PageUrl from '../components/PageUrl';
import { HubDbTable, MabVariantUrls } from '../components/HubDbDetailComponents';
import { jsx as _jsx } from "react/jsx-runtime";
export const DETAILS_HEADER_CONFIG_OVERRIDES = {
  [CONTENT_PLATFORM_PROPERTY_NAME.ABSOLUTE_URL]: {
    Description: PageUrl
  },
  [PAGE_PROPERTY_NAMES.MAB_EXPERIMENT_ID]: {
    Title: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.header.titles.hs_mab_experiment_id"
    }),
    Description: MabVariantUrls,
    hidden: contentCrmObject => {
      const mabExperimentId = getPropertyValue(contentCrmObject, PAGE_PROPERTY_NAMES.MAB_EXPERIMENT_ID);
      return !mabExperimentId;
    }
  },
  [PAGE_PROPERTY_NAMES.DYNAMIC_PAGE_DATA_SOURCE_ID]: {
    Title: () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.header.titles.hs_dynamic_page_data_source_id"
    }),
    Description: HubDbTable,
    hidden: contentCrmObject => {
      const dynamicPageHubDbTableId = getContentDynamicPageHubDbTableId(contentCrmObject);
      return !dynamicPageHubDbTableId;
    }
  }
};